
import { Vue, Component, Watch } from "vue-property-decorator";
@Component({
  filters: {
    formatFloatToPercent: (v: number) => parseFloat(`${v * 100}`).toFixed(2)
  }
})
export default class Longhubang extends Vue {
  public name: string = "Longhubang";
  headers: views.header[] = [
    {
      key: "index",
      title: "序列",
      width: 60
    },
    {
      title: "股票代码",
      key: "stockCode",
      width: 90
    },

    {
      title: "股票名称",
      key: "stockName",
      width: 100,
      align: "left"
    },
    {
      title: "价格",
      key: "price",
      width: 100,
      align: "left"
    },
    {
      title: "涨跌幅",
      key: "netChange",
      width: 100,
      align: "left"
    },
    {
      title: "日期",
      key: "endTime",
      width: 100,
      align: "right"
    }
  ];
  loading: boolean = true;
  tradingDay: number = 0;
  chineseBuyBoards: GAPI.longhuDataItem[] = [];
  chineseSellBoards: GAPI.longhuDataItem[] = [];
  foreignBuyBoards: GAPI.longhuDataItem[] = [];
  foreignSellBoards: GAPI.longhuDataItem[] = [];
  order: boolean = true;
  async fetchData() {
    const {
      data: {
        tradingDay = 0,
        chineseBuyBoards = [],
        chineseSellBoards = [],
        foreignBuyBoards = [],
        foreignSellBoards = []
      } = {}
    } = await this.$api.GetBoardLonghu();
    this.loading = false;
    this.tradingDay = tradingDay;
    this.chineseBuyBoards = chineseBuyBoards;
    this.chineseSellBoards = chineseSellBoards;
    this.foreignBuyBoards = foreignBuyBoards;
    this.foreignSellBoards = foreignSellBoards;
  }

  async mounted() {
    this.fetchData();
  }
}
